import {callSnowflakeQuery} from '@/services/SnowflakeService';
import type {GridData} from '@/components/DataTable/types';
import {getGenericGridData} from './gridBuilder';

// Visible by default — the columns explicitly called out in BMAPS-3403's
// completion criteria. Every other column from the SELECT list is hidden by
// default but still toggleable via the grid column menu.
const ORENNIA_VISIBLE_COLUMNS = [
  'PROXY_INTERCONNECTION_CAPACITY',
  'TOTAL_UPGRADE_COST',
  'NUMBER_OF_UPGRADES',
  'UPGRADE_TYPE',
  'ACHIEVABLE_RATING',
  'INDIVIDUAL_UPGRADE_COST',
  'UPGRADE_UNIT_COST',
];

export function getOrenniaInterconnectionCostGrid(
  _featureId: string,
  feature: Record<string, unknown>,
): GridData | null {
  // The Esri layer's idField is `objectid` (Esri row counter) but Snowflake's
  // BUS_ID matches the feature's `bus_id` (e.g. 'MISO_698380'). Read bus_id
  // directly rather than going through idField. Republishing the Esri layer to
  // align idField is tracked separately.
  const busId = feature?.bus_id;
  if (typeof busId !== 'string' || !busId) {
    console.error('Orennia bus feature is missing a string `bus_id`:', feature);
    return null;
  }
  return getGenericGridData(
    callSnowflakeQuery('getOrenniaInterconnectionCost', [busId]),
    {
      title: 'Interconnection Cost',
      mappingKey: 'Orennia Buses',
      visibleColumns: ORENNIA_VISIBLE_COLUMNS,
      useFieldLabelHeaders: true,
      subtitle: () => ` - ${busId}`,
    },
  );
}
